import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">

          <h2 className="text-3xl md:text-4xl font-bold">Education Qualification</h2>
        </div>
        <div className="mt-6 ml-[10px] lgl:ml-[100px] lgl:mt-14 lgl:w-[1100px] w-[320px] border-l-[5px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="BSc in Computer Science"
            subTitle="University of Mumbai (2019 - 2022)"
            result="8.04 CGPA"
            des="Graduated and acquired a comprehensive understanding of core programming concepts, algorithms, and software development. Had some experience in extracuriculars"
          />
          <ResumeCard
            title="Higher Secondary School Education"
            subTitle="Vani Vidhyalaya (2017 - 2019)"
            result="58.38/100"
            des=""
          />
          <ResumeCard
            title="Secondary School Education"
            subTitle="Vani Vidhyalaya (2011 - 2019)"
            result="78/100"
            des=""
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
